module.exports = __webpack_public_path__ + "static/flux-sketch-1-c3c45646b314eec120641f361ca439f2.jpg";